// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import ProfileActivity from 'app/common/react/components/profile/ProfileActivity/ProfileActivity';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';
import type { State } from 'app/common/redux/types';
import type { Viewer } from 'app/packages/pinterest-flow-types/viewer';
import withResource from 'app/common/lib/react/withResource';
import withRouteData from 'app/common/lib/react/withRouteData';
import { compose } from 'redux';
import { SingleTreatmentExp } from 'app/common/lib/experiment';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';

type Props = {
  data: Object,
  params: {|
    userId?: number,
    username: string,
  |},
  requestContext: RequestContextType,
  user: {
    data: ProfileUser,
  },
  viewer: { username: string },
};
function ProfileActivityContainer(props: Props) {
  const { user, params, viewer, requestContext } = props;
  const { username, userId } = params;
  if (!user || !user.data || !user.data.id || !user.data.username || !username) {
    return null;
  }

  const isOwnProfile = viewer.username === params.username;

  if (
    (isOwnProfile &&
      !new SingleTreatmentExp(requestContext, 'bizpro_web_self_view_ia').enabled()) ||
    (!isOwnProfile &&
      !new SingleTreatmentExp(requestContext, 'bizpro_web_pinner_view_ia').enabled())
  ) {
    return null;
  }

  return (
    <ProfileActivity
      isOwnProfile={isOwnProfile}
      user={user.data}
      username={username}
      userId={userId}
    />
  );
}

const mapStateToProps = (state: State, viewer: Viewer) => ({ viewer: state.viewer });

export default compose(
  // $FlowFixMe: Deprecated type. Using * types is not recommended! (deprecated-type)
  connect<Props, *, _, _, _, _, _>(mapStateToProps),
  withResource({
    name: 'UserResource',
    key: 'user',
    options: ({ params }) => ({
      username: params.username,
      field_set_key: 'profile',
    }),
  }),
  withRouteData({
    name: 'ProfileActivity',
    routeContextLog: (context: Object, params: { username: string }) => {
      let userId;
      if ((context.user || {}).username === params.username) {
        userId = context.user.id;
      }
      return {
        object_id_str: userId,
        view_type: PCONST.thrift.ViewType.USER,
        view_parameter: PCONST.thrift.ViewParameterType.USER_ACTIVITY,
      };
    },
  }),
  withRequestContext,
)(ProfileActivityContainer);
